import { camelcasify } from "@otto-ec/assets-core-utils/string";
import * as EVENTS from "./event.name.const";
import { PREFIX, type EventDefintion } from "./event.utils";
import type { EventType } from "./event.index";

export const defineSheetEvent = <T extends EventType>(
  eventName: T,
  legacyOpenClose: [api?: string, dom?: string][] = [],
  legacyContentChange: [api?: string, dom?: string][] = [],
): EventDefintion<T> => {
  const shortName = eventName.slice(PREFIX.length + 1);
  return [camelcasify(shortName) as never, eventName, legacyOpenClose, legacyContentChange];
};

//
/*                 */
//
export const PRESENTATION_START = defineSheetEvent(EVENTS.PRESENTATION_START);

declare const PRESENTATION_START_API: (typeof PRESENTATION_START)[0];
export { PRESENTATION_START_API };

//
/*               */
//
export const PRESENTATION_END = defineSheetEvent(EVENTS.PRESENTATION_END);

declare const PRESENTATION_END_API: (typeof PRESENTATION_END)[0];
export { PRESENTATION_END_API };

//
/*          */
//
export const BEFORE_OPEN = defineSheetEvent(
  EVENTS.BEFORE_OPEN,
  [[undefined, "oc-before-open"]],
  [["beforeContentChange", "oc-before-content-change"]],
);

declare const BEFORE_OPEN_API: (typeof BEFORE_OPEN)[0];
export { BEFORE_OPEN_API };

//
/*   */
//
export const OPEN = defineSheetEvent(
  EVENTS.OPEN,
  [[undefined, "oc-open"]],
  [
    ["switch", "oc-switch"],
    ["contentChangeShow", "oc-content-change-show"],
  ],
);

declare const OPEN_API: (typeof OPEN)[0];
export { OPEN_API };

//
/*    */
//
export const FLYIN = defineSheetEvent(EVENTS.FLYIN);

declare const FLYIN_API: (typeof FLYIN)[0];
export { FLYIN_API };

//
/*         */
//
export const AFTER_OPEN = defineSheetEvent(EVENTS.AFTER_OPEN, [[undefined, "oc-after-open"]]);

declare const AFTER_OPEN_API: (typeof AFTER_OPEN)[0];
export { AFTER_OPEN_API };

//
/*           */
//
export const BEFORE_CLOSE = defineSheetEvent(EVENTS.BEFORE_CLOSE, [[undefined, "oc-before-close"]]);

declare const BEFORE_CLOSE_API: (typeof BEFORE_CLOSE)[0];
export { BEFORE_CLOSE_API };

//
/*    */
//
export const CLOSE = defineSheetEvent(
  EVENTS.CLOSE,
  [[undefined, "oc-close"]],
  [["contentChangeHide", "oc-content-change-hide"]],
);

declare const CLOSE_API: (typeof CLOSE)[0];
export { CLOSE_API };

//
/*     */
//
export const FLYOUT = defineSheetEvent(EVENTS.FLYOUT);
declare const FLYOUT_API: (typeof FLYOUT)[0];
export { FLYOUT_API };

//
/*          */
//
export const AFTER_CLOSE = defineSheetEvent(EVENTS.AFTER_CLOSE, [[undefined, "oc-after-close"]]);

declare const AFTER_CLOSE_API: (typeof AFTER_CLOSE)[0];
export { AFTER_CLOSE_API };

//
/*            */
//
export const CONTENT_FETCH = defineSheetEvent(EVENTS.CONTENT_FETCH);

declare const CONTENT_FETCH_API: (typeof CONTENT_FETCH)[0];
export { CONTENT_FETCH_API };

//
/*            */
//
export const CONTENT_PARSE = defineSheetEvent(EVENTS.CONTENT_PARSE);

declare const CONTENT_PARSE_API: (typeof CONTENT_PARSE)[0];
export { CONTENT_PARSE_API };

//
/*            */
//
export const CONTENT_ERROR = defineSheetEvent(EVENTS.CONTENT_ERROR, [
  ["contentLoadingError", "oc-content-loading-error"],
]);

declare const CONTENT_ERROR_API: (typeof CONTENT_ERROR)[0];
export { CONTENT_ERROR_API };

//
/*            */
//
export const CONTENT_APPLY = defineSheetEvent(EVENTS.CONTENT_APPLY, [
  ["contentLoaded", "oc-content-loaded"],
]);

declare const CONTENT_APPLY_API: (typeof CONTENT_APPLY)[0];
export { CONTENT_APPLY_API };

//
/*              */
//
export const CONTENT_DISCARD = defineSheetEvent(EVENTS.CONTENT_DISCARD);

declare const CONTENT_DISCARD_API: (typeof CONTENT_DISCARD)[0];
export { CONTENT_DISCARD_API };
